import { Alert, Button } from "../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment } from "react";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { envVariables } from "../utils";
import { useSchoolConfig } from "../hooks";
var PermissionAlert = function PermissionAlert() {
  var tenantId = sessionStorage.getItem('tenantId');
  var sessionUser = JSON.parse(sessionStorage.getItem('user'));
  var apiBase = envVariables.apiBase;
  var _useSchoolConfig = useSchoolConfig(),
    msTeamsPermissionMissing = _useSchoolConfig.msTeamsPermissionMissing;
  var showAlert = msTeamsPermissionMissing && (sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.role) === 'teacher' && !(sessionUser !== null && sessionUser !== void 0 && sessionUser.email.match(/^(admin@m)(\w+)(\.onmicrosoft\.com)$/)); // temporarily disable permissions alert for microsoft admins

  var goToPermissionsPage = function goToPermissionsPage() {
    window.location.assign("".concat(apiBase, "/i/teams/").concat(tenantId, "/auth/permissions"));
  };
  var AlertContent = function AlertContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-md-flex justify-content-md-between flex-wrap"
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex-grow-1"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faWarning,
      className: "text-warning me-1 font-size-17"
    }), "Nurture doesn\u2019t have admin permission to read your class list. Features are limited."), /*#__PURE__*/React.createElement(Button, {
      className: "btn-sm mx-2",
      onClick: goToPermissionsPage
    }, "Grant admin access"));
  };
  return /*#__PURE__*/React.createElement(Fragment, null, showAlert && /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Alert, {
    allowDismiss: false,
    text: /*#__PURE__*/React.createElement(AlertContent, null),
    type: "info"
  })));
};
export default PermissionAlert;